import { httpClient } from "../http/httpClient";

export interface AuthorizationResponse {
  RegistrationNumber: string;
  EmployerDocumentNumber: number;
  Elegivel: boolean;
  ValorMargem: number;
}
export const requestAuthorization = async (cpf: string) => {
  const { data } = await httpClient.post<AuthorizationResponse[]>('/clt/authorization', { cpf });
  return data;
};